import React from "react";
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import checkPermissions from '../../shared/checkPermissions';
import checkPermissionsActions from '../../shared/checkPermissionsActions';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CommissionSplitsForm from "../../containers/CommissionSplits/CommissionSplitsForm";
import * as actions from '../../store/actions';
import CommissionSplitsList, { CS_VIEW_FILTERS_MODULE, CS_COLUMNS_META } from "../../containers/CommissionSplits/CommissionSplitsList";
import { ViewFiltersButton } from "../../components/ViewFiltersModal/useViewFilters";
import Loader from "../../components/Loader/Loader";
import Button from "../../components/CustomButtons/Button";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { Cached } from "@material-ui/icons";
import Notification from "../../components/Notification/Notification";
import { getParameterByName } from "shared/utility";
import { clone, cloneJ, handleError } from "../../shared/utility";
import { getUser } from "../../shared/authValidation";
import axios from 'store/axios/axios-commission-splits';
import NotificationAsk from "../../components/Notification/NotificationAsk";

class CommissionSplitsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'all',
      subFilter: 'all',
      data: [],
      openedForm: false,
      formData: null,
      formAction: null,
      entryData: null,
      notification: '',
      finalApproval: null,
      prefill_property_id: null,
      openCsplit: false,
      askBeforeDrafting: null,
      hiddenColumns: []
    }
  }

  updateCompleted = async (entryData) => {
    try {
      await axios.put('/entry', {
        status: 1,
        id: entryData.id
      })
    } catch(e) {
      handleError(e);
      return;
    }
    const entry = cloneJ(entryData);
    this.props.getCommissionSplitsHistory(entry.id);
    if (entry.json_data) {
      if (!entry.json_data.outside_brokers) {
        entry.json_data.outside_brokers = [];
      }
    }
    this.setState({
        entryData: entry,
        formData: entry.json_data,
        openedForm: true,
        formAction: 'edit',
        tab: 'my_drafts',
        askBeforeDrafting: null
    });
  }

  // 1: 'Saved to Draft',
  // 2: 'Submitted to Final Approver',
  // 3: 'Submitted to Pending Associates',
  // 4: 'Approved by Associate',
  // 5: 'Rejected by Associate',
  // 6: 'Rejected by Approver Level 1',
  // 7: 'Rejected by Final Approver',
  // 8: 'Sent to Pending Approval by Associate',
  // 9: 'Final Approval',
  // 10: 'Submitted to Approver Level 1',
  // 11: 'Approved, Sent for Docusign Signature',
  // 12: 'Pending Final Signature',
  // 13: 'Completed Docusign',
  // 14: 'Rejected Docusign by Associate',
  // 15: 'Initialed by Associate'
  // 16: 'Voided'

  reload = () => {
    if (this.state.tab === 'all') {
        const authorizations = checkPermissionsActions('CommissionSplits') || {};
        const isApprover = Object.keys(authorizations).some(item => item.toLowerCase().indexOf('approve') !== -1);
        if (isApprover) {
            this.props.getCommissionSplits({ status: [1, 2, 8, 10, 11, 12, 13, 15, 16] });
        } else {
            this.props.getCommissionSplits({
                assoc_combined: true,
                use_pending_agent_approval: true,
                open_statuses: [11, 15],
                own_statuses: [1, 13, 16]
            });
        }
        return;
    }
    if (this.state.tab === 'my_drafts') {
        this.props.getCommissionSplits({
            status: [1],
            own: true
        });
    } else if (this.state.tab === 'all_drafts') {
      this.props.getCommissionSplits({
            status: [1],
            own: false
        });
    } else if (this.state.tab === 'pending_associate_review') {
      this.props.getCommissionSplits({
          status: [8],
          pending_agent_approval: true
      });
    } else if (this.state.tab === 'pending_approver_review') {
        this.props.getCommissionSplits({
            status: [2,10,11,12],
            own: true
        });
    } else if (this.state.tab === 'pending_my_approval') {
      const permissions = checkPermissionsActions('CommissionSplits');
      const usr = getUser();
      const obj = {};
      let status = [];
      let hasApproverPerm = false;
      if (permissions) {
        Object.keys(permissions).forEach(p => {
          if (p === 'approve_level_1') {
            status.push(10);
            hasApproverPerm = true;
          }
          if (p === 'approve_level_2') {
            status.push(2);
            hasApproverPerm = true;
          }
        })
      }
      console.log('usr', usr);
      if (usr.type === 'A') {
        status.push(8);
      }
      obj.status = status;
      if (usr.type === 'A' && !hasApproverPerm) {
        obj.pending_agent_approval = true;
      }
      this.props.getCommissionSplits(obj);
    } else if (this.state.tab === 'all_completed') {
      this.props.getCommissionSplits({
        status: [13]
      });
    } else if (this.state.tab === 'my_completed') {
      this.props.getCommissionSplits({
        status: [13],
        own: true
      });
    } else if (this.state.tab === 'pending_signature') {
      this.props.getCommissionSplits({
        status: [11,15]
      });
    } else if (this.state.tab === 'final_signature') {
      this.props.getCommissionSplits({
        status: [12]
      });
    } else if (this.state.tab === 'all_voided') {
      this.props.getCommissionSplits({
        status: [16]
      });
    } else if (this.state.tab === 'my_voided') {
      this.props.getCommissionSplits({
        status: [16],
        own: true
      });
    }

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tab !== this.state.tab) {
        // load tab's data
        this.reload();
    }
    if (prevProps.data !== this.props.data) {
        console.log('data', this.props.data, prevProps.data);
        this.setState({ data: this.props.data });
    }
    if (prevProps.entryData !== this.props.entryData) {
      const obj = { entryData: clone(this.props.entryData) };
        if (this.state.openCsplit) {
          obj.formData = this.props.entryData.json_data;
          obj.openedForm = true;
          obj.formAction = 'edit';
          const action_type = getParameterByName('action_type', window.location.href);
          console.log('formAction', action_type);
          if (action_type) obj.formAction = action_type;
          obj.openCsplit = false;

          const property_id = getParameterByName('property_id', window.location.href);
          if (property_id) {
            window.history.replaceState(null, null, '/commission_splits?return_to_property='+property_id);
          } else {
            window.history.replaceState(null, null, '/commission_splits');
          }
        }
        this.setState(obj);
    }
  }

  componentDidMount() {
    // My Drafts
    this.reload();
    const finalApproval = getParameterByName('final_approval', window.location.href);
    const obj = {}
    if (finalApproval) {
      const authorizations = checkPermissionsActions('CommissionSplits');
      if (authorizations.hasOwnProperty('final_signature')) {
        obj.tab = 'final_signature',
        obj.finalApproval = finalApproval;
      }
    }
    const action = getParameterByName('p', window.location.href);
    const action_type = getParameterByName('action_type', window.location.href);
    if (action === 'new') {
        const permitted = checkPermissions("CommissionSplits");
        if (permitted) {
            const property_id = getParameterByName('property_id', window.location.href);
            if (property_id) {
              obj.prefill_property_id = parseInt(property_id);
              obj.openedForm = true;
              obj.formAction = 'add';
              obj.entryData = null;
              obj.formData = null;
            }
        }
    } else if (action === 'open') {
      const permitted = checkPermissions("CommissionSplits");
        if (permitted) {
            const cs_id = getParameterByName('cs_id', window.location.href);
            const tab = getParameterByName('tab', window.location.href);
            console.log('opening...', cs_id, tab, action_type)
            if (cs_id) {
              const obj = {
                openCsplit: true
              };
              if (action_type) {
                obj.formAction = action_type;
              } else {
                obj.formAction = 'view';
              }
              if (tab) {
                obj.tab = tab;
              }
              this.setState(obj)
              this.props.getCommissionSplit(cs_id);
              this.props.getCommissionSplitsHistory(cs_id);
              return;
            }
        }
    }
    if (Object.keys(obj).length > 0) this.setState(obj);
    this.setState({tab:'all'})
  }

  render() {
    const permitted = checkPermissions('CommissionSplits');
    console.log('CommissionSplitsPage', this.props, permitted);
    if (!permitted) {
      return <Redirect to="/dashboard" />;
    }
    const authorizations = checkPermissionsActions('CommissionSplits');
    console.log('authorizations', authorizations)

    const user = getUser();
    const userIsAnAssociate = user.type === 'A' ? true : false;

    const isAnApprover = Object.keys(authorizations).some(item => item.toLowerCase().includes('approve'));

    console.log('useri', userIsAnAssociate);

    return (
      <div style={{ marginTop: 20 }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>

                <CardIcon
                  color={this.state.tab === 'all' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'all', subFilter:'all'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>ALL</strong>
                </CardIcon>

                {authorizations.hasOwnProperty('submit') && <CardIcon
                  color={this.state.tab === 'my_drafts' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'my_drafts'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>My Drafts</strong>
                </CardIcon>}

                {isAnApprover && <CardIcon
                  color={this.state.tab === 'all_drafts' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'all_drafts'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>All Drafts</strong>
                </CardIcon>}

                <CardIcon
                  color={this.state.tab === 'pending_my_approval' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'pending_my_approval'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>Pending My Approval</strong>
                </CardIcon>

                <CardIcon
                  color={this.state.tab === 'pending_approver_review' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'pending_approver_review'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>Pending Further Approval</strong>
                </CardIcon>

                {authorizations.hasOwnProperty('submit') && <CardIcon
                  color={this.state.tab === 'pending_signature' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'pending_signature'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>Pending Sign</strong>
                </CardIcon>}

                {authorizations.hasOwnProperty('final_signature') && <CardIcon
                  color={this.state.tab === 'final_signature' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'final_signature'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>Pending Final Sign</strong>
                </CardIcon>}


                <CardIcon
                  color={this.state.tab === 'my_completed' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'my_completed'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>My Completed</strong>
                </CardIcon>

                {(authorizations.hasOwnProperty('final_signature') || authorizations.hasOwnProperty('approve_level_2')) && <CardIcon
                  color={this.state.tab === 'all_completed' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'all_completed'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>All Completed</strong>
                </CardIcon>}

                {(authorizations.hasOwnProperty('final_signature') || authorizations.hasOwnProperty('approve_level_2')) && <CardIcon
                  color={this.state.tab === 'all_voided' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'all_voided'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>All Voided</strong>
                </CardIcon>}

                <CardIcon
                  color={this.state.tab === 'my_voided' ? 'success' : 'rose'}
                  onClick={() => {
                    this.setState({tab:'my_voided'})
                  }}
                  className="hovered hovered-shadow piernos"
                >
                  <strong>My Voided</strong>
                </CardIcon>

              </CardHeader>
              <CardBody>  
                  {this.state.tab === 'my_drafts' && <div>
                    <Button color="rose" className="mr-20" onClick={() => {
                    this.setState({openedForm: true, formAction:'add', entryData: null, formData: null});
                  }}>ADD NEW</Button>
                  </div>}

                  {this.state.tab && <Button color="primary" size="sm" className="mr-20" onClick={() => {
                    this.reload();
                  }}><Cached /> Reload</Button>}

                  {this.state.tab === 'all' && <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, marginTop: 10, marginBottom: 10 }}>
                    <div style={{ maxWidth: 360, flex: '0 0 360px' }}>
                      <CustomSelect
                        label="Filter"
                        default={this.state.subFilter || 'all'}
                        options={[
                          { value: 'all', desc: 'All' },
                          { value: 'my_drafts', desc: 'My Drafts' },
                          { value: 'all_drafts', desc: 'All Drafts' },
                          { value: 'pending_associate_review', desc: 'Pending Associate Review' },
                          { value: 'pending_approver_review', desc: 'Pending Further Approval' },
                          { value: 'pending_signature', desc: 'Pending Sign' },
                          { value: 'final_signature', desc: 'Pending Final Sign' },
                          { value: 'my_completed', desc: 'My Completed' },
                          { value: 'all_completed', desc: 'All Completed' },
                          { value: 'my_voided', desc: 'My Voided' },
                          { value: 'all_voided', desc: 'All Voided' }
                        ]}
                        choose={(val) => {
                          this.setState({ subFilter: val });
                        }}
                        indx="value"
                        desc="desc"
                      />
                    </div>
                    <ViewFiltersButton
                      moduleName={CS_VIEW_FILTERS_MODULE}
                      columns={CS_COLUMNS_META}
                      tab={this.state.subFilter || 'all'}
                      onHiddenChange={(h) => this.setState({ hiddenColumns: h })}
                    />
                  </div>}
                  {this.state.tab !== 'all' && <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <ViewFiltersButton
                      moduleName={CS_VIEW_FILTERS_MODULE}
                      columns={CS_COLUMNS_META}
                      tab={this.state.tab}
                      onHiddenChange={(h) => this.setState({ hiddenColumns: h })}
                    />
                  </div>}

                  {this.props.loading_data && <Loader center={true} />}
                  {this.state.tab && <CommissionSplitsList
                    data={this.state.data}
                    tab={this.state.tab}
                    subFilter={this.state.subFilter}
                    hiddenColumns={this.state.hiddenColumns}
                    setTab={(t) => this.setState({ tab: t })}
                    authorizations={authorizations}
                    deleteCommissionSplit={this.props.deleteCommissionSplit}
                    updateCompleted={(entryData) => {
                      this.setState({
                        askBeforeDrafting: entryData
                      })
                    }}
                    openEntry={(entryData, shouldView, rowTab) => {
                      const entry = cloneJ(entryData);
                        this.props.getCommissionSplitsHistory(entry.id);
                        if (entry.json_data) {
                          if (!entry.json_data.outside_brokers) {
                            entry.json_data.outside_brokers = [];
                          }
                        }
                        const baseUpdate = {
                            entryData: entry,
                            formData: entry.json_data,
                            openedForm: true,
                            formAction: shouldView ? 'view' : 'edit'
                        };
                        if (this.state.tab === 'all' && rowTab) {
                            baseUpdate.tab = rowTab;
                        }
                        this.setState(baseUpdate);
                    }}
                    reload={this.reload}
                    success_delete={this.props.success_delete}
                    error_delete={this.props.error_delete}
                    getCsSigningUrl={this.props.getCsSigningUrl}
                    signing_url={this.props.signing_url}
                  />}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

        {this.state.openedForm && <CommissionSplitsForm 
            tab={this.state.tab}
            formData={this.state.formData}
            entryData={this.state.entryData}
            action={this.state.formAction}
            authorizations={authorizations}
            close={() => {
              const property_id = getParameterByName('return_to_property', window.location.href);
              if (property_id) {
                window.location.href = '/crm/properties?property_id='+property_id;
              } else {
                this.reload();
                this.setState({openedForm:false})
              }
            }}
            formAction={this.state.formAction}
            notification={this.state.notification}
            setNotification={(notification) => {
              this.setState({
                notification
              });
            }}
            prefill_property_id={this.state.prefill_property_id}
            reset_prefill_property_id={() => {
              this.setState({
                prefill_property_id: null
              })
            }}
        />}

        {this.state.notification && <Notification 
            message={this.state.notification}
            open={this.state.notification ? true : false}
            close={() => {
                this.setState({
                  notification: ''
                })
            }}
        />}

        {this.state.askBeforeDrafting && <NotificationAsk 
          title="Are you sure?"
          message="This will set the commission split entry back to Draft/Edit mode"
          open={this.state.askBeforeDrafting ? true : false}
          close={() => {
            this.setState({
              askBeforeDrafting: null
            })
          }}
          success={() => {
            this.updateCompleted(this.state.askBeforeDrafting);
          }}
        />}
      </div>
    );
  }
}

const mapStateToProps = state => {
    const cs = state.commission_splits;
    return {
        data: cs.data,
        loading_data: cs.loading_data,
        success_delete: cs.success_delete,
        error_delete: cs.error_delete,
        entryData: cs.entryData,
        signing_url: cs.signing_url
    }
}

const mapDispatchToProps = dispatch => {
  return {
    getCommissionSplits: (data) => {
        dispatch(actions.getCommissionSplits(data));
    },
    getCommissionSplit: (data) => {
      dispatch(actions.getCommissionSplit(data));
    },
    deleteCommissionSplit: (data) => {
        dispatch(actions.deleteCommissionSplit(data));
    },
    getCommissionSplitsHistory: (data) => {
        dispatch(actions.getCommissionSplitsHistory(data));
    },
    getCsSigningUrl: (data) => {
      dispatch(actions.getCsSigningUrl(data));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommissionSplitsPage);
